const inputLabel = document.querySelector('label[for="search-input-lot"]');
if (inputLabel) {
    const resultValue = document.querySelector('.search-lot-result');
    const btnCloseModal = document.querySelector('.btnCloseLot');
    const containerModal = document.createElement('div');
    const containerModalInner = document.createElement('div');
    const containerModalHeadline = document.createElement('span');
    const containerModalButton = document.createElement('a');
    const inputValue = inputLabel.children[0];
    const getItems = window.products;
    let interval;
    resultValue.appendChild(containerModal, resultValue);
    containerModal.appendChild(containerModalInner, containerModal);
    containerModalInner.appendChild(containerModalHeadline, containerModalInner);
    containerModalInner.appendChild(containerModalButton, containerModalInner); ``
    containerModal.classList.add('search-lot-results__wrapper');
    containerModalInner.classList.add('search-lot-results__inner');
    containerModalHeadline.classList.add('search-lot-results__heading');
    const heading = document.querySelector('.search-lot-results__heading');
    inputValue.addEventListener('keyup', (e) => {
        clearInterval(interval);
        heading.innerHTML = 'Searching...'; ``
        resultValue.style.display = 'block';
        interval = setInterval(async function () {
            if (inputValue.value == '') {
                heading.innerHTML = '';
                resultValue.style.display = 'none';
                containerModalButton.style.display = 'none';
            } else {
                const result = JSON.parse(getItems).filter(items => items.nro_lot == inputValue.value);
                if (result.length) {
                    result.forEach(items => {
                        const nroLotItem = items.nro_lot;
                        const urlLotItem = items.url_lot;
                        heading.innerHTML = `<strong>Lot Number:</strong><br/>${nroLotItem}`;
                        containerModalButton.style.display = 'inline-flex';
                        containerModalButton.classList.add('btn', 'button');
                        containerModalButton.setAttribute('href', urlLotItem);
                        containerModalButton.setAttribute('target', '_blank');
                        containerModalButton.innerText = 'Download PDF';
                    });
                } else {
                    heading.innerText = 'Sorry, this batch number does not exist or the value is incorrect';
                }
            }
            clearInterval(interval);
        }, 500);
    })
    btnCloseModal?.addEventListener('click', () => {
        inputValue.value = '';
        resultValue.style.display = 'none';
        containerModalButton.style.display = 'none';
    })
}